import useValidator from '../../../../utilities/useValidator';
import validators from '../../../../utilities/validators';

const useBankAvailableFinanceProductTypesValidation = () =>
    useValidator(validators.compose(validators.requiredArray('availableFinanceProductTypes')));

export default useBankAvailableFinanceProductTypesValidation;
